import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const StyledPageToolbar = styled(Grid)({
    marginBottom: "20px",
    marginTop: "20px",
});

const StyledLeftIcon = styled(Grid)({
    marginLeft: "25px",
});

const StyledButton = styled(Link)({
    textDecoration: "none",
});

const CrmToolbar = (props) => {
    const { contacts, filterQuery, addNewContact } = props;

    return (
        <StyledPageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">Contacts</h2>
                <div className="page-subtitle">
                    {`Showing ${contacts.length} ${contacts.length === 1 ? "contact" : "contacts"} `}
                    {filterQuery > "" && "(Filtered)"}
                </div>
            </Grid>

            <Grid item>
                <Grid container alignItems="center" spacing={0}>
                    <StyledLeftIcon item>
                        <StyledButton
                            to={{
                                pathname: "/contacts/create",
                                state: { newContact: true },
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={addNewContact}>
                                <Add /> Add New Contact
                            </Button>
                        </StyledButton>
                    </StyledLeftIcon>
                </Grid>
            </Grid>
        </StyledPageToolbar>
    );
};

export default CrmToolbar;
